import moment from 'moment';

export const formatEndDate = endDate => {
  if (Date.parse(endDate)) {
    return moment(endDate).format('l');
  }
  return 'No End Date';
};
